/**
 * TM-1000001726 Phase 3: Frontend-Spiegel des Backend-Enums
 * {@code CrudLookupByEnum}. Steuert ob UPDATE/DELETE/READ-Operationen die
 * Entity per ID oder per Filter-Kriterium suchen.
 *
 * @ticket TM-1000001726
 */
export enum CrudLookupByEnum {
    ID,
    CRITERIA
}
